import { AnimatePresence } from '@eversports/klimt-utilities/framer-motion'

import Footer from '../../components/Footer'
import Header from '../../components/Header'
import Search from '../../components/Search'

import NotFound from './NotFound'

const NotFoundScreen = () => {
  return (
    <>
      <Header position={{ xs: 'relative', lg: 'sticky' }}>
        <Search />
      </Header>
      <AnimatePresence mode="wait">
        <NotFound />
      </AnimatePresence>
      <Footer />
    </>
  )
}

export default NotFoundScreen
